import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  && .MuiFormLabel-root {
    margin-bottom: 6px;

    font-size: 12px;
  }

  .filepicker {
    min-height: 120px;
  }

  .dropzone .dz-message {
    margin: 42px 0;
  }
`;
